var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm10 md10" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.avl.label,
                              items: _vm.avlist,
                              "item-text": "avl",
                              "item-value": "avl"
                            },
                            on: { change: _vm.getVehiculosOptions },
                            model: {
                              value: _vm.formFields.avl.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.avl, "value", $$v)
                              },
                              expression: "formFields.avl.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.flota.label,
                              items: _vm.flotalist,
                              "item-text": "nombre",
                              "item-value": "id"
                            },
                            on: { change: _vm.getVehiculosOptionsPatente },
                            model: {
                              value: _vm.formFields.flota.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.flota, "value", $$v)
                              },
                              expression: "formFields.flota.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.patente.label,
                              items: _vm.patentelist,
                              "item-text": "patente_vehiculo",
                              "item-value": "patente_vehiculo"
                            },
                            model: {
                              value: _vm.formFields.patente.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.patente, "value", $$v)
                              },
                              expression: "formFields.patente.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm3: "", md3: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.dialog
        ? _c("VerEditarModal", {
            attrs: {
              codigoVehiculo: _vm.codigoVehiculo,
              nombre: _vm.nombre,
              flota: _vm.flota,
              patente: _vm.patente
            },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.dialog2,
            callback: function($$v) {
              _vm.dialog2 = $$v
            },
            expression: "dialog2"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Detalle del Vehículo: " + _vm._s(_vm.patente))]
              )
            ],
            1
          ),
          _c(
            "v-card",
            { attrs: { "max-height": "300", id: "bodyDialogInfo" } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "20px" } },
                [
                  _vm.jinfo.length == 0
                    ? _c("div", [
                        _c("li", [
                          _vm._v("\n            Sin Datos\n          ")
                        ])
                      ])
                    : _vm._e(),
                  _vm._l(_vm.jinfo, function(value, name) {
                    return _c(
                      "div",
                      { key: name, staticClass: "itemInfoDiv" },
                      [
                        _c("li", [
                          _c(
                            "strong",
                            { staticStyle: { "margin-right": "7px" } },
                            [_vm._v(_vm._s(name) + ": ")]
                          ),
                          _vm._v(
                            "\n            " + _vm._s(value) + "\n          "
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }